import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
// React-table library requires to import css as well:
import ReactTable from 'react-table';
import 'react-table/react-table.css'; // eslint-disable-next-line
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core';
import HighlightOff from '@material-ui/icons/HighlightOff';
import { orariControlli } from '../../../../utils/constants.js';

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: '190px',
      // maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 270,
    },
  },
};

const styles = (theme) => ({
  formcontrol: {
    marginBottom: '30px',
    width: '270px',
    padding: '0px 4px',
  },
  container: {
    margin: '10px 0px 14px 0px',
    padding: '10px 0px 14px 0px',
  },
  addButton: {
    color: theme.palette.text.main,
    margin: '10px',
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  tableContainer: {
    margin: '10px 0px 10px 0px',
    paddingBottom: '10px',
  },
});

class FormGiornaliero extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cadenza: {
        orario: '08:00:00',
        giornoSettimana: null,
        mese: null,
        giornoMese: null,
        schedaId: null,
        id: null,
        controlloConformitaId: null,
      },
    };
  }

  onSelect = (event) => {
    this.handleChange(event.target.name, event.target.value);
  };

  handleChange = (name, value) => {
    let cadenza = JSON.parse(JSON.stringify(this.state.cadenza));
    cadenza[name] = value;

    this.setState({
      cadenza,
    });
  };

  render() {
    const { classes } = this.props;

    const columns = [
      {
        Header: 'ID',
        id: 'id',
        accessor: (d) => d.id,
        show: false,
      },
      {
        Header: 'Orario',
        id: 'orario',
        accessor: (d) => d.orario,
        minWidth: 104,
      },
      {
        id: 'eliminaBtn',
        Header: 'Elimina',
        accessor: (row) => row,
        width: 90,
        Cell: (props) => (
          <IconButton
            size="small"
            disabled={false}
            onClick={() => {
              this.props.onDeleteCadenza(props.index);
            }}
            color="primary"
            title="Rimuovi cadenza"
          >
            <HighlightOff />
          </IconButton>
        ),
      },
    ];

    return (
      <Grid
        container
        justify="center"
        alignItems="center"
        className={classes.container}
      >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography variant="body1" style={{ fontWeight: 500 }} gutterBottom>
            Ora del controllo
          </Typography>
        </Grid>
        <FormControl className={classes.formcontrol}>
          <InputLabel id="orario-label">Ora</InputLabel>
          <Select
            labelId="orario-label"
            value={this.state.cadenza.orario}
            name="orario"
            onChange={this.onSelect}
            MenuProps={MenuProps}
          >
            <MenuItem disabled value={''}>
              <em>Seleziona un orario</em>
            </MenuItem>
            {orariControlli.map((orario) => (
              <MenuItem key={orario.value} value={orario.value}>
                {orario.label}
              </MenuItem>
            ))}
          </Select>
          <Button
            size="small"
            onClick={() => this.props.onAddCadenza(this.state.cadenza)}
            variant="contained"
            disabled={false}
            className={classes.addButton}
          >
            Aggiungi
          </Button>
        </FormControl>

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className={classes.tableContainer}
        >
          <ReactTable
            filterable={false}
            resizable={true}
            showPageSizeOptions={true}
            showPageJump={true}
            defaultPageSize={5}
            style={{
              height: 300,
              width: '100%',
            }}
            data={this.props.cadenze}
            columns={columns}
            previousText="Precedente"
            nextText="Successivo"
            noDataText="Nessun record"
            pageText="Pagina"
            ofText="di"
            rowsText="righe"
            pageJumpText="Vai a pagina"
            rowsSelectorText="righe per pagina"
          />
        </Grid>
      </Grid>
    );
  }
}

FormGiornaliero.propTypes = {
  cadenze: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  onAddCadenza: PropTypes.func.isRequired,
  onDeleteCadenza: PropTypes.func.isRequired,
};

export default withStyles(styles)(FormGiornaliero);
